import { Router } from '@angular/router';
import { Component } from '@angular/core';

import { AuthFacadeService } from '../../services/auth-facade.service';
import { routeNames } from '../../../../shared/route-names';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss',
})
export class LogoutComponent {
  constructor(private _authFacade: AuthFacadeService, private _router: Router) {
    this._authFacade.logout().subscribe(() => {
      this._router.navigate([routeNames.root]);
    });
  }
}
